export default __webpack_public_path__ + "static/media/my-location.c9df33af.svg";